import { render, staticRenderFns } from "./PrivateOnlineSessionIndex.vue?vue&type=template&id=f1fb423c&scoped=true&"
import script from "./PrivateOnlineSessionIndex.vue?vue&type=script&lang=js&"
export * from "./PrivateOnlineSessionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fb423c",
  null
  
)

export default component.exports